function CommonForm({
    formControls,
    formData,
    setFormData,
    handleSubmit,
    ButtonText,
    isBtnDisabled,
    formTitle
}) {
    function renderInput(controlItem) {
        const value = formData[controlItem.name] || "";

        switch (controlItem.componentType) {
            case "select":
                return (
                    <select
                        name={controlItem.name}
                        id={controlItem.name}
                        value={value}
                        onChange={(event) =>
                            setFormData({ ...formData, [controlItem.name]: event.target.value })
                        }
                        className="px-2 py-1 border rounded w-full"
                    >
                        <option value="" disabled>
                            {controlItem.placeholder || "Choisir ..."}
                        </option>
                        {controlItem.options?.map((option) => (
                            <option key={option.id} value={option.id}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                );

            case "textarea":
                return (
                    <textarea
                        name={controlItem.name}
                        id={controlItem.name}
                        placeholder={controlItem.placeholder}
                        value={value}
                        onChange={(event) =>
                            setFormData({ ...formData, [controlItem.name]: event.target.value })
                        }
                        className="px-2 py-1 border rounded w-full min-h-[120px]"
                    />
                );
            case "span":
                return (
                    <input
                        type={controlItem.type || "text"}
                        name={controlItem.name}
                        id={controlItem.name}
                        placeholder={controlItem.placeholder}
                        value={value}
                        readOnly
                        disabled
                        checked={controlItem.type === "checkbox" ? value : undefined}
                        onChange={(event) =>
                            setFormData({
                                ...formData,
                                [controlItem.name]:
                                    controlItem.type === "checkbox"
                                        ? event.target.checked
                                        : event.target.value
                            })
                        }
                        className={`${controlItem.type === "checkbox" ?
                            "checked:bg-teal-400 border rounded w-auto py-3 mt-[-20px]" :
                            "px-2 py-1 rounded focus:border-none w-full"}`}
                    />

                );
            case "file":
                return (
                    <input
                        type="file"
                        name={controlItem.name}
                        id={controlItem.name}
                        placeholder={controlItem.placeholder}
                        accept="image/*"
                        onChange={(event) => {
                            const file = event.target.files[0];
                            if (file && file.size > 5 * 1024 * 1024) { // Taille limite : 5MB
                                alert("Le fichier est trop volumineux !");
                            } else {
                                setFormData({
                                    ...formData,
                                    [controlItem.name]: file,
                                });
                            }

                        }
                        }
                        className={`${controlItem.type === "file" ?
                            "checked:bg-teal-400 border rounded w-auto py-3 mt-[-20px]" :
                            "px-2 py-1 rounded focus:border-none w-full"}`}
                    />

                );

            case "input":
            default:
                return (
                    <input
                        type={controlItem.type || "text"}
                        name={controlItem.name}
                        id={controlItem.name}
                        placeholder={controlItem.placeholder}
                        value={value}
                        readOnly={controlItem.options?.readOnly || ""}
                        checked={controlItem.type === "checkbox" ? value : undefined}
                        onChange={(event) =>
                            setFormData({
                                ...formData,
                                [controlItem.name]:
                                    controlItem.type === "checkbox"
                                        ? event.target.checked
                                        : event.target.value
                            })
                        }
                        className={`${controlItem.type === "checkbox" ?
                            "checked:bg-teal-400 border rounded w-auto py-3 mt-[-20px] mb-2" :
                            "px-2 py-1 border rounded w-full"}`}
                    />
                );
        }
    }

    return (
        <form onSubmit={handleSubmit} className="w-full">
            <h1 className="mb-4 font-semibold text-2xl text-center">
                {formTitle}
            </h1>
            <div
                className={`grid gap-4 ${formControls.length >= 6 ? "grid-cols-2" : "grid-cols-1"
                    }`}
            >
                {formControls.map((controlItem, index) => {
                    //Determine si les champs occupe une ligne entière
                    const isTextarea = controlItem.componentType === "textarea";
                    const isLastOddItem =
                        index === formControls.length - 1 &&
                        (formControls.length - 1) % 2 === 0

                    return (
                        <div
                            key={controlItem.name}
                            className={`flex flex-col gap-1 ${isTextarea || isLastOddItem ? "col-span-2" : ""
                                }`}
                        >
                            <label
                                htmlFor={controlItem.name}
                                className={`${controlItem.type === "checkbox" ?
                                    "mt-[26px]" :
                                    "font-medium text-sm"}`}
                            >
                                {controlItem.label}
                            </label>
                            {renderInput(controlItem)}
                        </div>
                    );
                })}
            </div>

            <button
                type="submit"
                disabled={isBtnDisabled}
                className="bg-blue-500 disabled:bg-gray-400 mt-4 px-4 py-2 rounded w-full text-white"
            >
                {ButtonText || "Valider"}
            </button>
        </form>
    );
}

export default CommonForm;
